import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/about-assets/hero/sky.webp")